import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import colors from "styles/colors";
import SearchIcon from "/static/svg/icons/search.svg";
import { StylesDirectoryHeaderContentComponent } from "./directory-header-content-component.scss";
class DirectoryHeaderContentComponent extends PureComponent {
    shouldShowSearch() {
        const { searchConfig } = this.props;
        return searchConfig && searchConfig.show;
    }
    onInputChange(event) {
        const { onSearchChange } = this.props;
        const { value } = event.target;
        return onSearchChange(value);
    }
    render() {
        const { title, subtitle, textColor, searchConfig, searchValue, onSearchChange } = this.props;
        return /*#__PURE__*/ _jsxs(StylesDirectoryHeaderContentComponent, {
            className: "directory-header-content-component",
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    dangerouslySetInnerHTML: {
                        __html: title
                    },
                    style: {
                        color: colors[textColor]
                    }
                }),
                /*#__PURE__*/ _jsx("h2", {
                    dangerouslySetInnerHTML: {
                        __html: subtitle
                    },
                    style: {
                        color: colors[textColor]
                    }
                }),
                this.shouldShowSearch() && /*#__PURE__*/ _jsxs("div", {
                    className: "search-input-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("input", {
                            placeholder: searchConfig.placeholder,
                            value: searchValue || "",
                            onChange: this.onInputChange
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "search-icon-container",
                            children: /*#__PURE__*/ _jsx(SearchIcon, {})
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.onInputChange = this.onInputChange.bind(this);
    }
}
export { DirectoryHeaderContentComponent as default };
